import { NonProductionDaySagas } from './NonProductionDays'
import { CreditorGroupSagas } from './CreditorGroup'

export default [
    ...NonProductionDaySagas,
    ...CreditorGroupSagas
]